export default __webpack_public_path__ + "static/og-image-757961da247e18be834fd6a2fdb4ce23.jpeg";